import React from "react";
import { CustomButtonWhite } from "../UI/CustomButtons";
import styles from "../../_css/Home.module.css";
import PlanGraph from "../UI/PlanGraph";
import _ from "lodash";
import { HOME_DATA_PLAN_CARD } from "../../data/staticDataHome";
import { useSelector } from "react-redux";

function PlanCard({ remainingDays }) {
  const userInfo = JSON.parse(sessionStorage.getItem("sal_userInfo"));
  const totalDays = userInfo?.subscription_duration;
  const planName = _.capitalize(userInfo?.subscription_type);
  const lang = useSelector((state) => state.language.lang);

  const { planCardTitle, planCardSubTitle, planCardExpiredTitle } = HOME_DATA_PLAN_CARD[lang];

  return (
    <div className={styles.planCard}>
      <div className={styles.planCardHeader}>
        <h6 className="text-white mb-3">
          {remainingDays < 1
            ? planCardExpiredTitle
            : planCardTitle
                .replace("{planName}", planName)
                .replace("{remainingDays}", remainingDays)}
        </h6>
        {/* {(planName !== "Premium" || remainingDays < 1) && (
          <CustomButtonWhite text={planCardSubTitle} />
        )} */}
      </div>
      <div className={styles.planCardGraph}>
        <PlanGraph
          totalDays={totalDays}
          remainingDays={remainingDays < 0 ? 0 : remainingDays}
        />
      </div>
    </div>
  );
}

export default PlanCard;
